<div>
    <input type="text" #name placeholder="Your Name">
    <input type="text" #gender placeholder="Gender">
  
    <button (click)="addToStore(name.value, gender.value)">Add to Table</button>
  </div>